import { render, staticRenderFns } from "./SubscriptionForm.Purchase.AddOnLegacy.vue?vue&type=template&id=5b639f12&scoped=true&"
import script from "./SubscriptionForm.Purchase.AddOnLegacy.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.AddOnLegacy.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.AddOnLegacy.vue?vue&type=style&index=0&id=5b639f12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b639f12",
  null
  
)

export default component.exports